import { render, staticRenderFns } from "./WechatArticleComponent.vue?vue&type=template&id=22a8b0e1&"
import script from "./WechatArticleComponent.vue?vue&type=script&lang=js&"
export * from "./WechatArticleComponent.vue?vue&type=script&lang=js&"
import style0 from "./WechatArticleComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports